<template>
  <section id="step7" class="p-content-plan-manual-step">
    <div class="l-container">
      <h2 class="c-title--x-large">
        STEP7 完成した記事をチェックする
      </h2>
      <div class="l-rows">
        <p>
          下記のライティングチェックシートを活用し、記事をチェックしていただくのがおすすめです。<br />
          <a :href="downloadUrl" class="c-link--underline">
            コンテンツライティングチェックシート30項目
          </a>
        </p>
        <p>
          チェックシートのすべての項目が完了し、内容に問題がなければ、記事をアップしてください。<br />
          ここまでの記事作成、お疲れさまでした!
        </p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    keyword: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    }
  },
  computed: {
    downloadUrl() {
      const organizationId = this.$store.getters['view/organization']
        .organizationId;
      return `${process.env.VUE_APP_CONTENT_PLAN_CHECK_SHEET_DOWNLOAD_URL}?organization_id=${organizationId}&created_at=${this.createdAt}&keyword=${this.keyword}`;
    }
  }
};
</script>
